"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unpackCssShorthand = void 0;
var unpackCssShorthand = exports.unpackCssShorthand = function unpackCssShorthand(shorthand) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  shorthand = [].concat(shorthand);
  for (var i = 1; i <= length; i++) {
    if (shorthand.length < i) {
      shorthand.push(shorthand[Math.floor(i / 2) - 1]);
    }
  }
  return shorthand;
};
//# sourceMappingURL=css-utils.js.map